import React from "react";
import styles from "./styles.module.css";

const TeamMember = ({ role, name, company, about, photo }) => {
  return (
    <>
      <div className={styles.teamMember}>
        <div className={styles.reverse}>
          <div>
            <h4 className={styles.role}>{role}</h4>
            <p className={styles.name}>{name}</p>
            <p className={styles.job}>{company}</p>
          </div>
          <div>
            <div className={styles.picContainer}>
              <div
                className={styles.pic}
                style={{ backgroundImage: `url(${photo})` }}
              ></div>
            </div>
          </div>
        </div>
        <p className={styles.teamDesc}>{about}</p>
      </div>
    </>
  );
};

const Team = ({ teacher }) => {
  return (
    <>
      <div className={styles.root}>
        <h4 className={styles.title}>Команда курса</h4>

        <div className={styles.grid}>
          {teacher.map((item, i) => (
            <TeamMember
              key={i}
              photo={item.photo.file.url}
              role={item.role}
              name={item.name}
              company={item.company}
              about={item.about.about}
            />
          ))}
        </div>
      </div>
    </>
  );
};

export default Team;
